import React, { useEffect, useState } from 'react'
import AdminNavbar from '../../../components/CommonComponents/AdminNavbar'
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName } from '../../../components/CommonMethod/CommonMethods';
import AdminTable from '../../../components/CommonComponents/AdminTable';
import { Link } from 'react-router-dom';
import MessageBox from '../../../components/CommonComponents/MessageBox';
import { IconDeleteFigma, IconDeleteSolid, IconSolidEdit } from '../../../Assets/MyIcons';
import { FaEllipsisVertical } from "react-icons/fa6";
import AdminDeleteModal from '../../../components/CommonComponents/AdminDeleteModal';
import { toast } from 'react-toastify';
import Response_Processing from '../../../layout/Others/Response_Processing';
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect';
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import AdminProcessButton from '../../../components/CommonComponents/AdminProcessButton';
import { RxReload } from 'react-icons/rx';
import { BiRecycle } from "react-icons/bi";
import { LiaUndoAltSolid } from "react-icons/lia";
import { useMyContext } from '../../../components/Provider/CommonProvider';
import { connect } from 'react-redux';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import { FaEye } from 'react-icons/fa';
import AdminTooltip from '../../../components/CommonComponents/AdminTooltip';
import useTablePage from '../../../components/CommonComponents/useTablePage';
import { SliderFormatterComponent } from '../../../components/CommonMethod/CommonBoostrapFormatter';
import AdminSliderModal from '../../../components/CommonComponents/AdminSliderModal';

const SeriesList = ({ permissionData }) => {
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/series-list`
  const multiDelete = `${BaseUrl}/admin/series/multi-delete`
  const seriesBannerApi = `${BaseUrl}/admin/series/slider/update`
  const { fetchRequest } = useMyContext()
  const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
  const [draft, setDraft] = useState(0);
  const [deleteActionType, setDeleteActionType] = useState(2);
  const [type, setType] = useState(null)
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState('')
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [activeId, setActiveId] = useState(null)
  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })

  const fetchData = async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        type, page,
        limit: formData?.title ? total?.count_all : limit,
        title: formData?.title,
        soft_delete: draft
      },
      data: {},
    })
      .then(response => {
        const result = response;
        const updatedList = result?.data?.map((item) => {
          const UploadStatus = findUploadName(item?.uploaded_by);
          let published = item?.active === 1 ? true : false
          let scheduled = item?.active == 2 ? true : false
          const statusText = published ? "PUBLISHED" : scheduled ? 'SCHEDULED' : "DRAFT"
          return {
            ...item,
            uploaded_by: UploadStatus,
            active: statusText
          };
        });
        setApiData(updatedList);
        setTotal(result?.pagination)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  };

  const fetchAllData = async (type, find) => {
    const data = await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        title: find == "ALL" ? null : formData?.title,
        type: null,
        page,
        limit: find == "ALL" ? total?.count_all : total?.totalItems,
        soft_delete: draft
      },
      data: {},
    })
    const updatedList = data?.data?.map((item) => {
      const UploadStatus = findUploadName(item?.uploaded_by);
      let published = item?.active === 1 ? true : false
      let scheduled = item?.active == 2 ? true : false
      const statusText = published ? "PUBLISHED" : scheduled ? 'SCHEDULED' : "DRAFT"
      return {
        ...item,
        uploaded_by: UploadStatus,
        active: statusText
      };
    });
    if (type == "CSV") {
      await donwloadCSV(updatedList, "SERIES-LIST")
    }
    if (type == "PDF") {
      await downloadPDF(updatedList, "SERIES-LIST", ["INDEX", "ID", "TITLE", "CATEGORY", "GENRE", "UPLOADED_BY", "STATUS"])
    }
    if (type == "XLSX") {
      await downloadXLSX(updatedList, "SERIES-LIST", ["INDEX", "ID", "TITLE", "CATEGORY", "GENRE", "UPLOADED_BY", "STATUS"])
    }
  };

  const handleConfirmDelete = async (actionType) => {
    setShowOverlay(true);
    await fetchRequest({
      method: 'DELETE',
      url: `${multiDelete}`,
      params: {},
      data: { id: itemToDelete, action: actionType || deleteActionType },
    })
      .then(response => {
        const result = response;
        if (result?.status) {
          toast.success(result?.message);
          setItemToDelete([])
        }
      })
      .catch(error => {
        toast.error(error?.response?.data?.message || error?.message)
      }).finally(() => {
        setShowOverlay(false)
        setWithoutRefresh(!withOutRefresh);
      })
  };

  const handleToggle = (item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  const confirmToggle = async () => {
    setShowOverlay(true);
    setShowModal(false);
    try {
      const newStatus = currentItem?.banner === 1 ? 0 : 1;
      const response = await fetchRequest({
        method: 'POST',
        url: `${seriesBannerApi}`,
        params: {},
        data: { id: currentItem?.id, banner_status: newStatus }
      });
      const result = response
      if (result.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setCurrentItem(null);
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setCurrentItem(null);
  };

  const closeDeleteModal = () => {
    setModelClose(!modelClose);
    setShowModal(false);
    setItemToDelete([])
    setDeleteActionType(2)
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    if (draft === 1) {
      setDeleteActionType(3)
    }
  };
  const singlePermanentDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    setDeleteActionType(1)
  }
  const handleDeletedata = (actionType) => {
    handleConfirmDelete(actionType);
    closeDeleteModal();
  };

  const seriesFormatter = (cell, row) => {
    return (
      <div className="d-flex justify-content-between align-items-center">
        <img src={row?.Thumbnail || row?.thumbnail} className="profile" alt="series_thumbnail" style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }} />
        <div className="rightVideoTitle">
          <h4 className='table-column-title mb-2'>{row?.title}</h4>
          <div className='d-flex align-items-center flex-wrap gap-2 justify-content-start'>
            <span className='dateText table-subheading theme-text-color'>{row?.category_name}</span>
            <span className='dateText table-subheading theme-text-color'>{row?.upload_on}</span>
            {permissionData?.userDetails?.id == row.user_id ? <span className='dateText table-subheading theme-text-color green-color-bg d-inline-block px-3 py-1 rounded-5'>{permissionData?.userDetails?.id == row.user_id ? "You" : ""}</span> : ""}
          </div>
        </div>
      </div>
    );
  };

  const statusFormatter = (cell, row) => {
    const isDisapproved = row?.active === 2 || row?.status === 2;
    const isPublished = row?.active === 1 || row?.active === "PUBLISHED";
    const isScheduled = row?.active === "SCHEDULED";
    const isUnpublished = row?.active === "UNPUBLISHED";
    
    const statusText = isDisapproved ? "DISAPPROVED" : row?.active;
    const statusClass = isPublished ? "PUBLISHED_active" : isScheduled ? "DISABLED_active" : "UNPUBLISHED_active";
    
    return (
      <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${statusClass}`}>
        {statusText}
      </div>
    );
  };

  const columns = [
    {
      dataField: "title",
      text: "Series",
      width: "40%",
      formatter: seriesFormatter,
      sort: true,
    },
    {
      dataField: "uploaded_by",
      text: "Upload by",
    },
    {
      dataField: "active",
      text: "Status",
      formatter: statusFormatter,
    },
    // {
    //   dataField: "banner",
    //   text: "Slider",
    //   formatter: (cell, row) => <SliderFormatterComponent cell={cell} row={row} action={handleToggle} />,
    // },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => {
        return <div className="editdropdown"
          onClick={() => setActiveId(row.id)}
          onMouseLeave={() => setActiveId(null)}
          id={`moreOption`}>
          <span className="editdropdown-button">
            <FaEllipsisVertical />
          </span>
          <div className={`editdropdown-menu theme-bg-color ${activeId == row?.id ? "d-block" : "d-none"}  ${formData?.view_type}`}>
            {draft !== 1 &&
              <Link id={`editLink`} to={`${"/edit-series/"}${row?.id}`} className="theme-text-color theme-bg-color">
                <span className="theme-text-color">
                  <IconSolidEdit className='ms-2' styled={{ width: "20px", height: "20px" }} />
                  <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                </span>
              </Link>}
            <div id={`deleteButton`} onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
              {draft == 1 ? <LiaUndoAltSolid style={{ width: "20px", height: "20px" }} /> : <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />}
              <MessageBox text={`${draft == 1 ? "undo" : "Delete"}`} classname='ms-2 theme-text-color'></MessageBox>
            </div>
            {draft == 1 && (<div id={`permanentDeleteButton`} onClick={() => singlePermanentDelete(row?.id)} className="commonActionPadding theme-bg-color">
              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Delete Permanent" classname='ms-2 theme-text-color'></MessageBox>
            </div>)}
          </div>
        </div>
      }
    },
  ];

  const column = [
    { label: "ID", key: "id" },
    { label: "TITLE", key: "title" },
    { label: "CATEGORY", key: "category_name" },
    { label: "GENRE", key: "genre_name" },
    { label: "UPLOADED BY", key: "uploaded_by" },
    { label: "STATUS", key: "active" },
    { label: "UPLOAD ON", key: "upload_on" },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
  };

  const selectRow = {
    selected: itemToDelete,
  };

  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };
  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }
  const reloadAction = () => {
    setDraft(0)
    setWithoutRefresh(prev => !prev)
  }
  const reCycleBin = () => {
    setDraft(prev => prev === 1 ? 0 : 1);
    setItemToDelete([]);
  };


  useEffect(() => {
    fetchData();
  }, [page, limit, formData?.title, withOutRefresh, draft]);

  useEffect(() => {
    if (draft === 0) {
      setDeleteActionType(2)
    }
    if (draft === 1) {
      setDeleteActionType(3)
    }
    if (draft === 1) {
      setDeleteActionType(1)
    }
  }, [draft])

  return (
    <div className='mb-4'>
      {modelClose && <AdminDeleteModal messageClassName={deleteActionType === 1 ? "warningColor" : ""} headingText={deleteActionType == 3 ? "Confirm Undo" : deleteActionType == 1 ? "Confirm Permanent Delete" : "Confirm Delete"} message={deleteActionType == 2 ? "Are you sure you want to delete" : deleteActionType == 3 ? "Are you sure you want to Undo item" : deleteActionType == 1 ? "Warning: This action will permanently delete the selected items from the server. Once deleted, the data cannot be recovered. Are you sure you want to proceed?" : "Are you sure you want to Delete"} modelClose={modelClose} deleteClose={closeDeleteModal} deleteAction={handleDeletedata} buttonText={"custom"} actionText={deleteActionType == 1 ? "Delete Permanent" : deleteActionType == 2 ? "Delete" : deleteActionType == 3 ? "Undo" : ""} />}
      {showOverlay && <Response_Processing />}
      {showModal && (
        <AdminSliderModal
          showModal={showModal}
          closeModal={closeModal}
          confirmToggle={confirmToggle}
        />
      )}
      <AdminNavbar heading={"All Series"} totalDataLength={total?.totalItems} deleteCount={0} navigation={"/add-series"} deleteMethod={openModal} navText={"Add Series"} />
      <div className='theme-bg-color p-3 rounded-3 mb-5'>
        <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
          <input type='search' placeholder='Search ' name="title" className='rounded-3 col-3 theme-border-color border-solid-width border-solid table-search  theme-bg-color-secondary' onChange={handleInput} id='searchInput' />
          <div className='d-flex align-items-center justify-content-end'>
            {(draft !== 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete" className={"warningColorBg me-2"} saveMethod={() => { setModelClose(true); setDeleteActionType(2) }} /> : ""}
            {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Undo" className={"mx-3"} saveMethod={() => { setModelClose(true); setDeleteActionType(3) }} /> : ""}
            {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete Permanent" className={"me-3"} saveMethod={() => { setModelClose(true); setDeleteActionType(1) }} /> : ""}
            <button id="recycleButton" className={`reloadButton custom-tool-tip-parent p-2 me-2  border border-2 rounded-circle theme-border-color ${draft ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`} onClick={reCycleBin}>
              <BiRecycle style={{ width: "18px", height: "15px" }} />
              <AdminTooltip text="Recycle Bin" top={"-41px"} className="d-none custom-tool-tip" />
            </button>
            <button id="reloadButton" className={`bg-transparent custom-tool-tip-parent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
              <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
              <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
            </button>
            <div className='position-relative custom-tool-tip-parent'>
              <AdminCustomSelect name="view_type" value={formData?.view_type} onChange={handleInput} options={formData?.view_type_option?.map((item, index) => ({ name: item?.name, value: item?.value }))} defaultOptionName={""} className="px-4 py-2 select-view-type" noMargin id="viewTypeSelectOption" />
              <AdminTooltip text="View Type" top={"-41px"} className="d-none custom-tool-tip" />
            </div>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                <li id="exportCSV" className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV")}>CSV</li>
                <li id="exportPDF" className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF")}>PDF</li>
                <li id="exportXLSX" className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX")}>XLSX </li>
              </ul>
            </div>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export All</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                <li id="exportallCSV" className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                <li id="exportallPDF" className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                <li id="exportallXLSX" className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
              </ul>
            </div>
          </div>
        </div>

        <AdminTable data={apiData}
          loading={loading}
          options={options}
          handlePageChange={handlePageChange}
          page={page}
          pagination={total}
          handleSizePerPageChange={handleSizePerPageChange}
          columns={columns}
          limit={limit}
          selectRow={selectRow}
          multiSelect
          onRowSelect={handleRowSelect}
          onSort={handleSort}
          onSelectAll={handleSelectAll}
          viewType={formData?.view_type}
        />
      </div>
    </div >
  )
}

const mapStateToProps = (state) => ({
  permissionData: state.userPermission.permissionData,
});
export default connect(mapStateToProps)(SeriesList);
